export const initializeRUM = () => {
  const deploymentEnvironment = process.env.REACT_APP_STAGE;
  const collectionSourceUrl = process.env.REACT_APP_SUMO_LOGIC_RUM_COLLECTOR;

  if (deploymentEnvironment && collectionSourceUrl) {
    const sumoScript = document.createElement('script');
    sumoScript.src = 'https://rum.sumologic.com/sumologic-rum.js';
    sumoScript.type = 'text/javascript';
    document.head.appendChild(sumoScript);
    sumoScript.onload = function () {
      if (!window.sumoRumInitialized && window.sumoLogicOpenTelemetryRum) {
        window.sumoRumInitialized = true;
        window.sumoLogicOpenTelemetryRum.initialize({
          collectionSourceUrl,
          serviceName: 'checkout-ui',
          applicationName: 'checkout-ui',
          samplingProbability: 1,
          collectErrors: true,
          propagateTraceHeaderCorsUrls: [
            /^https:\/\/dxp-bettacart-bff-sit\.svc\.platform\.myobdev\.com\/.*/,
            /^https:\/\/dxp-bettacart-bff-production\.svc\.platform\.myob\.com\/.*/,
            /^https:\/\/dxp-bettacart-bff-production\.svc\.metis-prod\.jupiter\.myob\.com\/.*/
          ],
          deploymentEnvironment,
          ignoreUrls: [
            /^https:\/\/myob\.74xz8u\.net\/.*/,
            /^https:\/\/.*\.adsrvr\.org\/.*/,
            /^https:\/\/.*\.bing\.com\/*/,
            /^https:\/\/.*\.clarity\.ms\/.*/,
            /^https:\/\/.*\.doubleclick\.net\/.*/,
            /^https:\/\/.*\.facebook\.com\/.*/,
            /^https:\/\/(.*\.)?fxctag\.com\/.*/,
            /^https:\/\/.*\.googletagmanager\.com\/.*/,
            /^https:\/\/.*\.google-analytics\.com\/.*/,
            /^https:\/\/analytics\.google\.com\/.*/,
            /^https:\/\/.*\.linkedin\.com\/.*/,
            /^https:\/\/.*\.ninetailed\.co\/.*/,
            /^https:\/\/.*\.pinterest\.com\/.*/,
            /^https:\/\/.*\.redditstatic\.com\/.*/,
            /^https:\/\/.*\.reddit\.com\/.*/,
            /^https:\/\/.*\.redditstatic\.com\/.*/,
            /^https:\/\/.*\.segmentapis\.com\/.*/,
            /^https:\/\/.*\.segment\.com\/.*/,
            /^https:\/\/.*\.segment\.io\/.*/,
            /^https:\/\/.*\.split\.io\/.*/,
            /^https:\/\/.*\.tiktok\.com\/.*/,
            /^https:\/\/.*\.twitter\.com\/.*/,
            /^https:\/\/(.*\.)?t\.co\/.*/
          ]
        });
      }
    };
    sumoScript.onerror = function() {
      console.error('Failed to load Sumo Logic RUM script');
    };
  }
}
